export class ApiUnauthorizedError extends Error {
    constructor(message = 'Unauthorized: Invalid token') {
        super(message);
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 401
        });
        this.name = 'ApiUnauthorizedError';
    }
}
export function isUnauthorizedError(error) {
    if (error instanceof ApiUnauthorizedError) {
        return true;
    }
    return (error instanceof Error &&
        (error.message.includes('401') ||
            error.message.toLowerCase().includes('unauthorized') ||
            error.message.toLowerCase().includes('invalid token')));
}
export async function buildApiError(response) {
    let message = response.statusText || 'Request failed';
    try {
        const body = (await response.json());
        message = body.error || body.message || message;
    }
    catch {
        // Some endpoints may not return JSON error bodies.
    }
    if (response.status === 401) {
        return new ApiUnauthorizedError(message);
    }
    return new Error(message);
}
//# sourceMappingURL=api-error.service.js.map